import { render } from "./IntroductionSection.vue?vue&type=template&id=15c4f1e0&scoped=true"
import script from "./IntroductionSection.vue?vue&type=script&lang=js"
export * from "./IntroductionSection.vue?vue&type=script&lang=js"

import "./IntroductionSection.vue?vue&type=style&index=0&id=15c4f1e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c4f1e0"]])

export default __exports__